import styled, {css} from 'styled-components';

import {breakpoint} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: end;
    flex-wrap: wrap-reverse;
    gap: 0.8rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    & > div {
        width: 25%;
        min-width: 250px;
    }

    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    min-width: 60px;
    gap: 10px;
`;

export const Action = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${(props) =>
        props.disabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `}
`;
